import { ArrowDown, ArrowUp, CheckCircle, Clock, FileText, TrendingUp, ScanSearch, SquareCheck } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, ResponsiveContainer,  Tooltip, XAxis, YAxis } from 'recharts';
import { ApiCall, getDateAndTime, handleDateChange } from '../../CommonComponents/CustomHooks';
import { NotificationSound } from '../../CommonComponents/CommonNotification';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { useDispatch } from "react-redux";
import { DateBox, FormButton } from '../../CommonComponents/InputBox';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { handleDownloadExcel } from '../../CommonComponents/ExportData';
import { Table } from '../../CommonComponents/Table';
import { initializeFilterData } from '../../CommonComponents/EnvConfig';
import MuiTooltip from '@mui/material/Tooltip';

const SalesOrderDashboard = () => {

    const [dashboardData, setDashboardData] = useState(null);
    const dispatch = useDispatch();
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [selectedCardDetails, setSelectedCardDetails] = useState('')
    const InitialState = {
        "fromDate": getDateAndTime(7).date,
        "toDate": getDateAndTime().date,
    }

    const [formData, setFormData] = useState(InitialState)

    const getDashboardData = async () => {
        await dispatch(setSubLoading(true))
        let payloadData = {
            ...formData
        }
        let res = await ApiCall(`/api/Dashboard/SalesOrderDashboard`, payloadData)
        await dispatch(setSubLoading(false))
        if (res.status === 'SUCCESS') {
            setDashboardData(res.data);
        } else if (res.status === 'ERROR') {
            setDashboardData(null);
        }
        await dispatch(setSubLoading(false))
        if (res.status === 'EXPIRED') {
            await NotificationSound(res.status, res.message, res.focus, null);
        }
    };

    const stats = dashboardData?.stats || [];
    const lineData = dashboardData?.lineData || [];
    const barData = dashboardData?.barData || [];
    const pieData = dashboardData?.pieData || [];
    const recentActivity = dashboardData?.recentActivity || [];

    const getActivityIcon = (type) => {
        switch (type) {
            case 'success': return 'bg-green-100 text-green-600';
            case 'info': return 'bg-blue-100 text-blue-600';
            case 'error': return 'bg-red-100 text-red-600';
            case 'warning': return 'bg-yellow-100 text-yellow-600';
            default: return 'bg-gray-100 text-gray-600';
        }
    };

    const handleClear = () => {
        setFormData(InitialState)
        inputrefs.current['txtFromDate'].focus()
     
    }

    const handleCardClick = async (CurrentPage = currentPageNo,cardData) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        } 
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            ...formData,
            CallType: cardData ? cardData:'',
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Dashboard/SalesOrderDashboardDetail`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }


    //--handle Modal function--/
    const [showModalBox, setShowModalBox] = useState(false)


    const handleModalDocShowClose = async () => {
        await setShowModalBox(false)
     
    };

    const handleBoxClick = (pageNo, value) => {
       
        setSelectedCardDetails(value.key)
        handleCardClick(1, value.key)
        setShowModalBox(true)
    }

    const handleChange1 = (event, value) => {
        handleCardClick(value, selectedCardDetails);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
        handleCardClick(currentPageNo, selectedCardDetails);
    };
    const extraPayload = {
        ...filterData,
        ...formData,
        CallType: selectedCardDetails ? selectedCardDetails : '',
    }

    useEffect(() => {
        //getDashboardData();
        inputrefs.current['txtFromDate'].focus()
    }, []);


    return (
        <>
        <div className="min-h-screen bg-gray-50">
          

                <div className="px-4 py-2 ">
                    <h6 className="text-base font-semibold mb-2">Dashboard</h6>

                <div className="flex flex-wrap items-center gap-3">
                        <DateBox
                            inputrefs={inputrefs}
                            label="From Date"
                            placeholder="From Date"
                            id="txtFromDate"
                            preventOpenOnFocus={true}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') inputrefs.current['txtToDate'].focus();
                            }}
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                        />

                        <DateBox
                            inputrefs={inputrefs}
                            label="To Date"
                            placeholder="To Date"
                            id="txtToDate"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') inputrefs.current['txtSearch'].focus();
                            }}
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                        />

                      
                        <div className="flex items-center gap-1 ">
                            <button
                                type="button"
                                onClick={getDashboardData}
                                ref={(ref) => (inputrefs.current['txtSearch'] = ref)}
                                className="flex items-center justify-center w-8 h-8 rounded-full bg-green-500 hover:bg-green-600 text-white text-xs transition-colors"
                            >
                                <i className="fa fa-search"></i>
                            </button>

                            <button
                                type="button"
                                id="txtBtn"
                                onClick={handleClear}
                                className="flex items-center justify-center w-8 h-8 rounded-full bg-red-500 hover:bg-red-600 text-white text-xs transition-colors"
                            >
                                <i className="fa-solid fa-arrow-rotate-left"></i>
                            </button>
                        </div>
                    </div>
                </div>
        
            <main className="max-w-[1600px] mx-auto px-3 py-2">
               
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                    {stats.map((stat, index) => (
                        <div key={index} className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow" onClick={() => { handleBoxClick(1, stat) }}>
                            <div className="flex items-center justify-between" >
                                <div className="flex-1">
                                    <p className="text-gray-500 text-xs font-medium">{stat.label}</p>
                                    <p className="text-2xl font-bold mt-1 text-gray-800">{stat.value}</p>
                                 
                                </div>
                                <div className={`${stat.color} p-3 rounded-lg`}>
                                    {(() => {
                                        const Icon = { FileText, Clock, CheckCircle, TrendingUp, ScanSearch, SquareCheck }[stat.icon];
                                        return Icon ? <Icon size={24} className="text-white" /> : null;
                                    })()}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Charts Row */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
                    {/* Line Chart */}
                    <div className="lg:col-span-2 bg-white rounded-lg shadow p-4">
                        <div className="flex justify-between items-center mb-3">
                            <div>
                                <h3 className="text-sm font-bold text-gray-800">Quotations & Revenue Trend</h3>
                                <p className="text-xs text-gray-500 mt-0.5">Monthly performance overview</p>
                            </div>
                            
                        </div>
                        <ResponsiveContainer width="100%" height={240}>
                            <AreaChart data={lineData}>
                                <defs>
                                    <linearGradient id="colorQuotations" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#ec1f24" stopOpacity={0.3} />
                                        <stop offset="95%" stopColor="#ec1f24" stopOpacity={0} />
                                    </linearGradient>
                                    <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="5%" stopColor="#00adef" stopOpacity={0.3} />
                                        <stop offset="95%" stopColor="#00adef" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                <XAxis dataKey="month" tick={{ fontSize: 11 }} stroke="#9ca3af" />
                                <YAxis tick={{ fontSize: 11 }} stroke="#9ca3af" />
                                <Tooltip contentStyle={{ fontSize: '12px', borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />
                                <Legend wrapperStyle={{ fontSize: '12px' }} />
                                <Area type="monotone" dataKey="quotations" stroke="#ec1f24" strokeWidth={2} fillOpacity={1} fill="url(#colorQuotations)" />
                                <Area type="monotone" dataKey="revenue" stroke="#00adef" strokeWidth={2} fillOpacity={1} fill="url(#colorRevenue)" />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>

                        {/* Pie Chart */}
                        <div className="bg-white rounded-lg shadow p-4">
                            <div className="mb-3">
                                <h3 className="text-sm font-bold text-gray-800">Status Distribution</h3>
                            </div>
                            <ResponsiveContainer width="100%" height={260}>
                                <PieChart>
                                    <Pie
                                        data={pieData}
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={90}
                                        innerRadius={0}  
                                        dataKey="value"
                                        labelLine={false}
                                        label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
                                    >
                                        {pieData.map((entry, index) => (
                                            <Cell key={index} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend
                                        verticalAlign="bottom"
                                        align="center"
                                        iconType="circle"
                                        wrapperStyle={{ marginTop: 20 }}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    {/*<div className="bg-white rounded-lg shadow p-4">*/}
                    {/*    <div className="mb-3">*/}
                    {/*        <h3 className="text-sm font-bold text-gray-800">Status Distribution</h3>*/}
                    {/*        <p className="text-xs text-gray-500 mt-0.5">Current quotation status</p>*/}
                    {/*    </div>*/}
                    {/*    <ResponsiveContainer width="100%" height={240}>*/}
                    {/*        <PieChart>*/}
                    {/*            <Pie*/}
                    {/*                data={pieData}*/}
                    {/*                cx="50%"*/}
                    {/*                cy="50%"*/}
                    {/*                innerRadius={50}*/}
                    {/*                outerRadius={80}*/}
                    {/*                paddingAngle={5}*/}
                    {/*                dataKey="value"*/}
                    {/*            >*/}
                    {/*                {pieData.map((entry, index) => (*/}
                    {/*                    <Cell key={`cell-${index}`} fill={entry.color} />*/}
                    {/*                ))}*/}
                    {/*            </Pie>*/}
                    {/*            <Tooltip contentStyle={{ fontSize: '12px', borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />*/}
                    {/*        </PieChart>*/}
                    {/*    </ResponsiveContainer>*/}
                    {/*    <div className="grid grid-cols-2 gap-2 mt-3">*/}
                    {/*        {pieData.map((item, index) => (*/}
                    {/*            <div key={index} className="flex items-center gap-2">*/}
                    {/*                <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.color }}></div>*/}
                    {/*                <span className="text-xs text-gray-600">{item.name}: {item.value}</span>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>

                {/* Second Row Charts & Activity */}
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mb-6">
                    {/* Bar Chart */}
                    <div className="lg:col-span-3 bg-white rounded-lg shadow p-4">
                        <div className="flex justify-between items-center mb-3">
                            <div>
                                <h3 className="text-sm font-bold text-gray-800">Top Categories</h3>
                                <p className="text-xs text-gray-500 mt-0.5">Quotations by product category</p>
                            </div>
                            <select className="text-xs border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-[#00adef]">
                                <option>This Month</option>
                                <option>Last Month</option>
                                <option>This Year</option>
                            </select>
                            </div>
                         
                        <ResponsiveContainer width="100%" height={220}>
                            <BarChart data={barData}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                <XAxis dataKey="category" tick={{ fontSize: 11 }} stroke="#9ca3af" />
                                <YAxis tick={{ fontSize: 11 }} stroke="#9ca3af" />
                                <Tooltip contentStyle={{ fontSize: '12px', borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }} />
                                <Bar dataKey="value" fill="#00adef" radius={[8, 8, 0, 0]} />
                            </BarChart>
                                </ResponsiveContainer>
                            
                    </div>

                    {/* Recent Activity */}
                    <div className="bg-white rounded-lg shadow p-4">
                        <div className="mb-3">
                            <h3 className="text-sm font-bold text-gray-800">Recent Activity</h3>
                            <p className="text-xs text-gray-500 mt-0.5">Latest updates</p>
                        </div>
                            <div className="space-y-3 max-h-60 overflow-y-auto pr-1">
                            {recentActivity.map((activity, index) => (
                                <div key={index} className="flex gap-2">
                                    <div className={`w-7 h-7 rounded-full ${getActivityIcon(activity.type)} flex items-center justify-center flex-shrink-0`}>
                                        <div className="w-1.5 h-1.5 rounded-full bg-current"></div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-xs font-medium text-[#1f2937] font-bold truncate ">{activity.action}</p>
                                        <MuiTooltip 
                                            title={activity.client}
                                            arrow
                                            placement="top"
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        fontSize: '11px',
                                                        bgcolor: '#1f2937',
                                                    },
                                                },
                                            }}
                                        >
                                            <p className="text-xs text-gray-500 truncate cursor-pointer">
                                                {activity.client}
                                            </p>
                                        </MuiTooltip>
                                        <p className="text-xs text-gray-400 mt-0.5">{activity.time}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </main>
            </div>



            <Dialog
                open={showModalBox}
                onClose={handleModalDocShowClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={false}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "1000px",
                        }

                    },
                    "& .css-hz1bth-MuiDialog-container": {
                        alignItems: 'center'
                    },
                    "& .MuiPaper-root": {
                        width: '95vw',
                        maxWidth: '1000px',
                        borderRadius: '8px',
                    },
                }}>

                <DialogTitle
                    id="alert-dialog-title"
                    className="p-3 border-bottom d-flex justify-content-between align-items-center"
                >
                    <div style={{ fontWeight: 500 }}> {selectedCardDetails || "Total Details"} </div>
                    <div className="d-flex align-items-center gap-3">
                        <FormButton
                            divclassname="items-end"
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleExport={async () => {
                                const payload = {
                                    ...extraPayload
                                };
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/Dashboard/SalesOrderDashboardDetail`, payload, selectedCardDetails)
                                await dispatch(setSubLoading(false))
                            }}
                            save={false}
                            search={false}
                            Export={true}
                            Reset={false}
                        />
                        <i
                            className="fa-solid fa-xmark"
                            onClick={handleModalDocShowClose}
                            title="Close"
                            style={{ cursor: 'pointer', fontSize: '20px', padding: '2px', borderRadius: '5px' }}
                        />
                    </div>
                </DialogTitle>


                <DialogContent className='main-card m-2 p-2' >

                    <Table
                        loading={isLoading}
                        PageName={'SalesOrderDashboard'}
                        handleFilter={() => {
                            handleCardClick(currentPageNo, selectedCardDetails)
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={tableData}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                        Filter={false}
                        onlyFilterPage={true}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default SalesOrderDashboard;